import "./style.scss";

import { CalendarTodayOutlined } from "@mui/icons-material";
import classNames from "classnames";
import StatusPill from "components/shared/ManagementPeriodComponent/StatusPill";
import { formatDates } from "components/shared/ManagementPeriodComponent/utils";
import { useTranslation } from "react-i18next";
import type { TPeriod } from "store/periodStore";

interface IPeriodSelectorPreview {
    period?: TPeriod;
    className?: string;
}

/**
 * Read-only inline preview of the management period selector (dates + status pill).
 */
const PeriodSelectorPreview = ({ period, className }: IPeriodSelectorPreview) => {
    const [t] = useTranslation();

    if (!period) {
        return null;
    }

    return (
        <span className={classNames("period-selector-preview", className)} title={formatDates(period)}>
            <CalendarTodayOutlined className="period-selector-preview__calendar" aria-hidden />
            <span className="period-selector-preview__dates">{formatDates(period)}</span>
            <StatusPill status={period.isActive} t={t} />
        </span>
    );
};

export default PeriodSelectorPreview;
